import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface HeaderSubtitleProps {
  subtitle: string;
  subtitleFontSize?: keyof typeof textVariants;
  className?: string;
}

export const HeaderSubtitle = memo(function HeaderSubtitle({
  subtitle,
  subtitleFontSize = "bodySingleLine",
  className,
}: HeaderSubtitleProps) {
  return (
    <h2
      className={cn(
        textVariants[subtitleFontSize],
        "line-clamp-1 flex-1 text-center leading-normal text-black",
        className,
      )}
    >
      {subtitle}
    </h2>
  );
});
